import { IPartialReducer } from "../../../../core/core-redux/reduxTypes";
import { Wms3dLayersState } from "../../wms3dLayers.reducer";

export const wms3dLayerLoadedPartialReducer: IPartialReducer<Wms3dLayersState> = () => {
    return {
        loading: false,
    };
};
